import "./index.css";

export default function Spiners() {

    return (
        <div className="fixed left-0 top-0 w-full h-full flex items-center justify-center bg-[#48c380] z-[9999]">

            <div className="loader"></div>

        </div>
    )
}
